import React, { FC } from 'react'

import { useNavigate } from 'react-router-dom'

import { Breadcrumb } from 'src/Components/Breadcrumb'
import { ArtistRoutesEnum } from 'src/Router/ArtistComponentsNewUI'

export const TikTokDetailsBreadcrumbs: FC = () => {
  const navigate = useNavigate()

  const breadcrumbItems = [
    {
      title: 'Campaigns',
      path: ArtistRoutesEnum.CampaignsList,
    },
    {
      title: 'Campaign Details',
      path: '',
    },
  ]

  const onBreadcrumbButtonClick = (): void => {
    navigate(ArtistRoutesEnum.CampaignsList)
  }

  return (
    <Breadcrumb
      items={breadcrumbItems}
      onButtonClick={onBreadcrumbButtonClick}
    />
  )
}
